module.exports = __webpack_public_path__ + "static/media/workingmemory-words-12.7d307a53.mp3";